import { lazy } from 'react';

export const SubscriptionPaymentAsync = lazy(
  () => import('./SubscriptionPayment')
);
